import prodConfig from '../config/config.prod.json';
import devConfig from '../config/config.dev.json';
import stageConfig from '../config/config.stage.json';
import testConfig from '../config/config.test.json';
import localConfig from '../config/config.local.json';
import localDevConfig from '../config/config.localDev.json';

const currentHost = window.location.host;

export const isProd = prodConfig.appUrls?.some((host) => currentHost.includes(host)) ?? false;
export const isStage = stageConfig.appUrls?.includes(currentHost) ?? false;
export const isDev = devConfig.appUrls?.includes(currentHost) ?? false;
export const isTest = testConfig.appUrls?.includes(currentHost) ?? false;
export const isLocalDevInContainer = false;
export const isRelease = window.location.host.includes('release-v');

interface Config {
  env: string;
  apiUrlTest?: string;
  apiUrl: string;
  appUrls?: string[];
  gtmId?: string;
  gtmIdTest?: string;
  usercentricsSettingsId?: string;
  externalLinkAgencyCheckout: string;
  newCustomerFormDomain: string;
  hideMultipleBookedLines: boolean;
}

let config: Config;

if (isProd) {
  console.log('isProduction or release');
  config = prodConfig;
} else if (isStage || isRelease) {
  console.log('isStage');
  config = stageConfig;
} else if (isTest) {
  console.log('isTest');
  config = testConfig;
} else if (isDev) {
  console.log('isDev');
  config = devConfig;
} else if (isLocalDevInContainer) {
  console.log('isLocalDev');
  config = localDevConfig;
} else {
  console.log('isNot Production or Stage config.ts');
  config = localConfig;
}

export default config;
